import { System } from '../System';
import { Entity } from '../Entity';
import { TransformComponent } from '../components/TransformComponent';
import { HealthComponent } from '../components/HealthComponent';
import { EventBus } from '../../utils/EventBus';

/**
 * HealingAuraSystem - Player heals nearby party members over time
 */
export class HealingAuraSystem extends System {
  public readonly requiredComponents = ['transform', 'health'];

  /** Healing radius in world units */
  private healRadius = 1;

  /** Heal amount per tick */
  private healAmount = 50;

  /** Time between heals in ms */
  private healInterval = 5000;

  /** Last heal time */
  private lastHealTime = 0;

  public init(): void {
    this.lastHealTime = Date.now();
  }

  public update(entities: Entity[], _delta: number): void {
    const currentTime = Date.now();

    // Only heal every healInterval
    if (currentTime - this.lastHealTime < this.healInterval) {
      return;
    }

    this.lastHealTime = currentTime;

    // Find player
    const player = entities.find((e) => e.hasTag('player'));
    if (!player) return;

    const playerTransform = player.getComponent<TransformComponent>('transform');
    if (!playerTransform) return;

    // Find party members within range and heal them
    for (const entity of entities) {
      if (!entity.hasTag('party_member')) continue;

      const transform = entity.getComponent<TransformComponent>('transform');
      const health = entity.getComponent<HealthComponent>('health');

      if (!transform || !health) continue;

      // Skip if dead or at full health
      if (!health.isAlive || health.current >= health.max) continue;

      // Check distance
      const distance = playerTransform.distanceTo(transform);

      if (distance <= this.healRadius) {
        const healed = health.heal(this.healAmount);
        if (healed > 0) {
          EventBus.emitEvent('beastie:healed', {
            id: entity.id,
            amount: healed,
          });
        }
      }
    }
  }

  public destroy(): void {
    // No cleanup needed
  }
}
